import { useState } from "react";
import { Checkbox } from "primereact/checkbox";
import { Button, ButtonType } from "components/Button/Button";
import "./PreviewControlPanel.scss";

const PreviewControlPanel = ({ onExitPreview, setPreviewLockedLearningJourneys }) => {
	const [unlocked, setUnlocked] = useState(false);

	const handleToggle = (e) => {
		setUnlocked(e.checked);
		setPreviewLockedLearningJourneys(e.checked);
	};

	return (
		<div className="preview-control-panel">
			<div className="preview-control-panel-checkbox">
				<Checkbox inputId="learningJourneyLock" checked={unlocked} onChange={handleToggle} />
				<label htmlFor="learningJourneyLock">
					Show Locked Learning Journeys
				</label>
			</div>
			<div className="preview-control-panel-exit">
				<Button
					type={ButtonType.Secondary}
					text="Exit Preview"
					onClick={onExitPreview}
				/>
			</div>
		</div>
	);
};

export default PreviewControlPanel;